export default {"src":"/_next/static/media/star-symbol.55ae0d6a.svg","height":111,"width":115,"blurWidth":0,"blurHeight":0};